import React, { useEffect, useState } from "react";
import CircularChart from "./CircularChart";
import HorizontalBarChart from "./HorizontalBarChart";
import EmployeeLeaveList from "./EmployeeLeaveList";
import "./PayrollDashboard.css";
import { LeaveOpeningAPI } from "../../../../api/Payroll/Leaveopening";

const notifications = [
  "6 - SUNITA KRISHNA KADAM has applied for Casual Leave from 03/07/2025 to 03/07/2025",
  "25 - SONIA YOGESH PATEL has applied for Casual Leave from 03/07/2025 to 03/07/2025",
  "25 - SONIA YOGESH PATEL has applied for Casual Leave from 04/07/2025 to 04/07/2025",
  "25 - SONIA YOGESH PATEL has applied for Casual Leave from 05/07/2025 to 05/07/2025",
  "56 - DIVYA BALAKRISHNA KURUP has not filled Bank Details under Payroll Setting Section",
  "76 - BINA KUMAR has not filled Bank Details under Payroll Setting Section",
  "150 - AMRITA MUKHERJEE has not filled Bank Details under Payroll Setting Section",
  "151 - PRIYANKA PRAKASH BELOSHE has not filled Bank Details under Payroll Setting Section",
  "153 - MANISHA SRIVASTAVA has not filled Bank Details under Payroll Setting Section",
  "154 - SMITA RAJIV SHINDE has not filled Bank Details under Payroll Setting Section",
];

const leaveApplications = [
  {
    id: 1,
    employeeName: "Sunita Krishna Kadam",
    leaveType: "Casual Leave",
    fromDate: "03/07/2025",
    toDate: "03/07/2025",
    status: "Pending",
  },
  {
    id: 2,
    employeeName: "Sonia Yogesh Patel",
    leaveType: "Casual Leave",
    fromDate: "04/07/2025",
    toDate: "04/07/2025",
    status: "Approved",
  },
  {
    id: 3,
    employeeName: "Divya Balakrishna Kurup",
    leaveType: "Sick Leave",
    fromDate: "05/07/2025",
    toDate: "06/07/2025",
    status: "Rejected",
  },
  {
    id: 4,
    employeeName: "Manisha Srivastava",
    leaveType: "Maternity Leave",
    fromDate: "01/07/2025",
    toDate: "31/07/2025",
    status: "Pending",
  },
];

const birthdayList = [
  {
    initial: "S",
    name: "SURBHI SUDHIR SHEDGE",
    phone: "7709896017",
    email: "samikshasoorofficial@gmail.com",
    date: "01",
  },
  {
    initial: "V",
    name: "VAISHALI NATHA OWALEKAR",
    phone: "9321163314",
    email: "samikshasoorofficial@gmail.com",
    date: "05",
  },
  {
    initial: "T",
    name: "TRUPTI YASHWANT TANDEL",
    phone: "9820171823",
    email: "samikshasoorofficial@gmail.com",
    date: "10",
  },
];

const PayrollDashboard = () => {
  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "approved":
        return "success";
      case "rejected":
        return "danger";
      case "pending":
      default:
        return "warning";
    }
  };

  const user = JSON.parse(localStorage.getItem("school_user"));

  const { user_detail } = user || {};
  const [filter, setFilter] = useState("thisWeek");
  const [dashboardData, setDashboardData] = useState(null);
  const getDashboardData = async (filter) => {
    let data = {
      school_id: user_detail?.fk_school_id,
      week: filter === "thisWeek" ? "current" : "next",
    };

    const response = await LeaveOpeningAPI.get_leave_dashboard_data(data);
    if (response.data.status === 200) {
      setDashboardData(response.data);
      // console.log("Dashboard Data: ", response.data);
    }
  };

  useEffect(() => {
    getDashboardData(filter);
  }, [filter]);

  const getInitials = (name) => {
    const nameParts = name.split(" ");
    return nameParts.map((part) => part.charAt(0).toUpperCase()).join("");
  };

  // Function to get the day of the week
  const getDayOfWeek = (dob) => {
    const date = new Date(dob);
    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    return daysOfWeek[date.getDay()];
  };

  function formatDate(dateString) {
    const date = new Date(dateString); // Convert string to Date object
    const day = String(date.getDate()).padStart(2, "0"); // Ensure day is two digits
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
    const year = date.getFullYear();

    return `${day}/${month}/${year}`; // Return in dd/mm/yyyy format
  }

  function getDay(dateString) {
    const date = new Date(dateString); // Convert string to Date object
    const day = String(date.getDate()).padStart(2, "0"); // Ensure day is two digits

    return day; // Return only the day part
  }

  return (
    <div className="container py-4">
      <div className="row g-4">
        <div className="col-md-6">
          <div className="card h-100 shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Notification</h5>
             <ul className="list-group notification-list">
  {dashboardData?.pending_applications.length === 0 ? (
    <li
      className="list-group-item text-center no-notification"
      style={{
        padding: "20px",
        marginTop: "10px",
        backgroundColor: "#f8f9fa",
        borderRadius: "8px",
      }}
    >
      No notification available
    </li>
  ) : (
    dashboardData?.pending_applications.map((note, index) => (
      <li key={index} className="list-group-item notification-item">
        <div className="notification-details">
          <p className="notification-text">
            <strong>{note.staff_name}</strong> has applied for{" "}
            <em>{note.leave_type}</em> leave from{" "}
            <span className="notification-date">{note.from_date}</span> to{" "}
            <span className="notification-date">{note.to_date}</span>
          </p>
        </div>
      </li>
    ))
  )}
</ul>


            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card h-100 shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Leave Application</h5>
              <ul className="list-group leave-list">
                {dashboardData?.all_applications.length === 0 ? (
                  <li
                    className="list-group-item text-center"
                    style={{ padding: "20px", marginTop: "10px" }}
                  >
                    No data available
                  </li>
                ) : (
                  dashboardData?.all_applications.map((leave) => (
                    <li
                      key={leave.id}
                      className="list-group-item d-flex justify-content-between align-items-start"
                    >
                      <div>
                        <strong>{leave.staff_name}</strong>
                        <br />
                        {leave.leave_type} from {leave.from_date} to{" "}
                        {leave.to_date}
                        <br />
                        {/* <span>{leave.number_of_leaves} days</span> */}
                        <small>Reason: {leave.reason}</small>
                      </div>
                      <span
                        className={`badge bg-${getStatusColor(
                          leave.status
                        )} rounded-pill`}
                      >
                        {leave.status}
                      </span>
                    </li>
                  ))
                )}
              </ul>
            </div>
          </div>
        </div>

        <div className="col-md-6 mb-2 mt-2">
          <div className="card h-100 shadow-sm mb-2">
            <div className="card-body">
              <h5 className="card-title">Overall Statistics</h5>
              <CircularChart
                data={[
                  dashboardData?.overview_stats?.total_staff || 0,
                  dashboardData?.overview_stats?.new_joinees_this_month || 0,
                  dashboardData?.overview_stats?.on_leave_today || 0,
                ]}
              />
            </div>
          </div>
        </div>

        {/* <div className="col-md-6 mb-2">
          <div className="card h-100 shadow-sm mb-2">
            <div className="card-body">
              <h5 className="card-title">Income & Spend</h5>
              <HorizontalBarChart
                categories={["Income", "Spend"]}
                data={[50000, 20000]}
              />
            </div>
          </div>
        </div> */}

        <div className="col-md-6 mt-2">
          <div className="card h-100 shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Current Month Birthday</h5>
              <ul className="list-group birthday-list">
                {dashboardData?.birthdays_this_month.length === 0 ? (
                  <li
                    className="list-group-item text-center"
                    style={{ padding: "20px", marginTop: "10px" }}
                  >
                    No data available
                  </li>
                ) : (
                  dashboardData?.birthdays_this_month.map((person, idx) => (
                    <li
                      key={idx}
                      className="list-group-item d-flex align-items-start"
                    >
                      {/* Displaying initials */}
                      <div className="avatar-a me-3">
                        {getInitials(person.name)}
                      </div>

                      <div className="flex-grow-1">
                        <strong>{person.name}</strong>
                        <br />
                        {/* Displaying Day of the Week */}
                        <span className="text-muted">
                          {getDayOfWeek(person.dob)}
                        </span>
                        <br />
                        <span className="text-muted">
                          {formatDate(person.dob)}
                        </span>{" "}
                        {/* You can format this date as you like */}
                      </div>

                      {/* Displaying the birthday date */}
                      <div className="date-badge">{getDay(person.dob)}</div>
                    </li>
                  ))
                )}
              </ul>
            </div>
          </div>
        </div>

        <div className="col-md-6 mb-2">
          <div className="card h-100 shadow-sm mb-2">
            <div className="card-body">
              <EmployeeLeaveList
                data={dashboardData?.approved_leaves_data || []}
                setFilter={setFilter}
                filter={filter}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayrollDashboard;
